<template>
  <div class="boxInfo">
    <div class="addFormBox">
      <el-button
        size="small" type="primary"
        icon="el-icon-plus"
        class="mb10"
        @click="Add"
      >{{ $t('receivablePayable.AddRow') }}</el-button>

      <el-form
        ref="tableForm"
        :model="formData"
        label-width="0px"
        class="error-form"
        :rules="rules"
        size="small"
      >
        <virtual-scroll
          ref="virtualScroll"
          :key="key"
          :data="formData.dataList"
          :item-size="76"
          key-prop="key"
          @change="(virtualList) => list = virtualList"
        >
          <el-table
            ref="tableRef"
            :data="list"
            row-key="key"
            border
            class="table-height"
            :height="tableHeightRow.height"
            :highlight-current-row="false"
          >
            <virtual-column width="80" type="index" />
            <el-table-column :label="$t('receivablePayable.Month')">
              <template #header>
                <div>
                  <!--月份-->
                  <span style="color: red;">*</span>
                  <span>{{ $t('receivablePayable.Month') }}</span>
                </div>
              </template>
              <template #default="scope">
                <el-form-item
                  v-if="scope.row.isNew"
                  :prop="`dataList.${scope.$index}.month`"
                  :rules="rules.month"
                >
                  <el-date-picker
                    v-model="scope.row.month"
                    type="month"
                    value-format="yyyy-MM"
                    :placeholder="$t('basicData.PleaseSelect')"
                    @change="changeValidate(scope)"
                  />
                </el-form-item>
                <span v-else>{{ scope.row.month }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('receivablePayable.Month')">
              <template #header>
                <div>
                  <!--币种-->
                  <span style="color: red;">*</span>
                  <span>{{ $t('receivablePayable.Currency') }}</span>
                </div>
              </template>
              <template #default="scope">
                <el-form-item
                  v-if="scope.row.isNew"
                  :prop="`dataList.${scope.$index}.currency`"
                  :rules="rules.currency"
                >
                  <el-select
                    v-model="scope.row.currency"
                    :placeholder="$t('basicData.PleaseSelect')"
                    style="width: 100%;"
                    @change="changeValidate(scope)"
                  >
                    <el-option
                      v-for="item in CURRENCY"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <span v-else>{{ scope.row.currency }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('basicData.exchangeRate')">
              <template #header>
                <div>
                  <!--汇率-->
                  <span style="color: red;">*</span>
                  <span>{{ $t('basicData.exchangeRate') }}</span>
                </div>
              </template>
              <template #default="scope">
                <el-form-item
                  v-if="scope.row.isNew"
                  :prop="`dataList.${scope.$index}.rate`"
                  :rules="rules.rate"
                >
                  <el-input v-model="scope.row.rate" :placeholder="$t('basicData.PleaseSelect')" clearable />
                  <!--                  <el-input-number-->
                  <!--                    v-model="scope.row.rate" :precision="2" :step="0.1"-->
                  <!--                    :max="100"-->
                  <!--                    :controls="false"-->
                  <!--                  />-->
                </el-form-item>
                <span v-else>{{ scope.row.rate }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('basicData.operate')" width="160">
              <template #default="scope">
                <div class="flex">
                  <div v-if="scope.row.id">
                    <el-button
                      v-if="!scope.row.isNew" size="mini" type="primary"
                      style="margin-right: 5px"
                      @click="handelEdit(scope)"
                    >{{ $t('CenterForSorting.modify') }}</el-button> <!--  修改 -->
                    <!--                    <div v-else>-->
                    <!--                      <el-button-->
                    <!--                        size="mini" type="primary"-->
                    <!--                        style="margin-right: 5px"-->
                    <!--                        @click="Update(scope)"-->
                    <!--                      >{{ $t('GlobalSetObj.Confirm') }}</el-button>  &lt;!&ndash;  确定 &ndash;&gt;-->

                    <!--                      <el-link :underline="false" @click="handelCancel(scope.$index)">{{ $t('basicData.Cancel') }}</el-link>-->
                    <!--                    </div>-->
                  </div>
                  <!--确定删除吗？-->
                  <el-popconfirm
                    :title="$t('basicData.AreYouSureYouWantToDelete')"
                    @confirm="handleDel(scope)"
                  >
                    <template #reference>
                      <!--删除-->
                      <!--  v-show="!scope.row.isNew || (scope.row.isNew && !scope.row.id)"-->
                      <el-button type="danger" size="mini">{{ $t('basicData.Delete') }}</el-button>
                    </template>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </virtual-scroll>
      </el-form>
    </div>

    <div class="addFooter">
      <!--取消-->
      <el-button size="small" @click="close">{{ $t('basicData.Cancel') }}</el-button>
      <!--保存-->
      <el-button
        v-permit:remove="'btn:finance:reportDashboard:feishu:paymentDetails:exchangeRate'"
        size="small" type="primary"
        @click="Save"
      >{{ $t('basicData.Save') }}</el-button>
    </div>
  </div>
</template>

<script>
import VirtualScroll, { VirtualColumn } from 'el-table-virtual-scroll';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight';
import { CURRENCY } from './enums';
import { apiFeishuExpenseExchangeRate, apiFeishuExpenseExchangeRateSave, apiFeishuExpenseExchangeRateDelete } from '@/api/finance/dataDheet';

export default {
  components: {
    VirtualScroll,
    VirtualColumn
  },

  mixins: [estimateTableHeight],

  data() {
    return {
      CURRENCY,
      formData: {
        dataList: []
      },
      list: [],
      rules: {
        month: [
          { required: true, message: this.$t('receivablePayable.PleaseSelectMonth'), trigger: 'blur' }
        ],
        currency: [
          { required: true, message: this.$t('receivablePayable.PleaseSelectCurrency'), trigger: ['blur', 'change'] }
        ],
        rate: [
          { required: true, message: this.$t('receivablePayable.PleaseEnterExchangeRate'), trigger: ['blur', 'change'] },
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                return callback(new Error(this.$t('GlobalSetObj.pleaseInput')));
              }

              const reg = /^([1-9]\d*(\.\d{1,2})?|0\.[1-9]\d?|0\.\d[1-9])$/;
              if (reg.test(value) === false) {
                return callback(new Error(this.$t('basicData.NumericWithTwoDecimals')));
              }
              return callback();
            },
            trigger: 'change'
          }
        ]
      },
      key: new Date().getTime(),
      isEdit: true // 是否是编辑状态
    };
  },
  methods: {
    open() {
      this.getList();
      this.key = new Date().getTime();
      // 重置状态
      this.isEdit = true;
    },
    // 获取列表
    getList() {
      const params = {
        pageNum: 1,
        pageSize: 9999,
        params: {}
      };
      apiFeishuExpenseExchangeRate(params).then(res => {
        if (res.code === 200) {
          this.formData.dataList = (res.data.records || []).map(item => {
            return {
              ...item,
              key: this.generateUniqueKey(item.id),
              isNew: false
            };
          });
        }
      });
    },
    // 编辑、只能编辑一行
    handelEdit(scope) {
      const { $index } = scope;
      if (!this.isEdit) {
        return;
      }
      this.$set(this.formData.dataList[$index], 'isNew', true);
      this.isEdit = false;
    },
    // 更新
    // Update(scope) {
    //   const { row, $index } = scope;
    //   const { id, month, currency, rate } = row;
    //   apiFeishuExpenseExchangeRateUpdate({
    //     id,
    //     month,
    //     currency,
    //     rate
    //   }).then(res => {
    //     if (res.code === 200) {
    //       this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
    //       this.$set(this.formData.dataList[$index], 'isNew', false);
    //       this.isEdit = true;
    //     }
    //   });
    // },
    // 取消编辑
    // handelCancel(index) {
    //   this.$set(this.formData.dataList[index], 'isNew', false);
    //   this.isEdit = true;
    // },
    // 新增
    Add() {
      this.formData.dataList.push({
        month: '',
        currency: '',
        rate: '',
        isNew: true,
        key: `item-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
      });
    },
    // 删除
    handleDel(scope) {
      const { row, $index } = scope;
      const { id } = row;
      if (id) {
        apiFeishuExpenseExchangeRateDelete(id).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
            this.getList();
            this.isEdit = true;
          }
        });
      } else {
        this.formData.dataList.splice($index, 1);
      }
    },
    // 保存
    Save() {
      const { dataList } = this.formData;
      console.log('Save', dataList);
      const data = dataList.filter(item => item.isNew).map(items => {
        const { id, month, currency, rate } = items;
        return {
          id,
          month,
          currency,
          rate
        };
      });
      if (!data.length) {
        this.$message.error(this.$t('receivablePayable.PleaseAddExchangeRate'));
        return;
      }
      this.$refs.tableForm.validate(valid => {
        if (valid) {
          apiFeishuExpenseExchangeRateSave(data).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
              this.getList();
              this.isEdit = true;
            }
          });
        } else {
          console.log('invalid');
        }
      });
    },
    // 校验月份+币种是否重合
    changeValidate(scope) {
      const { row, $index } = scope;
      const { month, currency } = row;
      const { dataList } = this.formData;

      // 排除当前行，检查其他行是否存在相同的月份+币种组合
      const isExist = dataList.some((item, index) =>
        index !== $index && item.month === month && item.currency === currency
      );

      if (isExist) {
        this.$message.warning(this.$t('basicData.MonthCurrencyExists', { month, currency }));
        return false;
      }

      return true;
    },
    close() {
      console.log('close');
      this.$emit('close');
    },
    generateUniqueKey(index) {
      return `item-${Date.now()}-${index}-${Math.random().toString(36).substr(2, 9)}`;
    }
  }
};
</script>

<style scoped lang="scss">
.boxInfo {
  height: 100%;

  .addFormBox {
    height: calc(100vh - 125px);
    padding: 15px;
    overflow-y: auto;
  }

  .addFooter {
    border-top: 1px solid #ccc;
    padding: 10px;
    text-align: right;
  }
}
</style>
